import { PlayerAhoyEvent } from "./player_ahoy_event";
import { PlayerEnvironment } from "./player_environment";
import Throttle from '@javascripts/utils/throttle';

export default class PlayerKeyboardPress {
  constructor(tech, uuid, data) {
    this._tech = tech;
    this._uuid = uuid;
    this._data = data;
    this._skipInterval = 5;
    this._throttleInterval = 300;
    this._time = Date.now();
    this._eventTimestamp = {};
    this._whitelistedKeys = [
      'ArrowRight',
      'ArrowLeft',
      'ArrowUp',
      'ArrowDown',
      'Space',
      'KeyK'
    ];
  }

  init() {
    this.setAhoyEventGlobalProperties();
    this.bindKeydown();
    this.bindKeyup();
  }

  bindKeyup() {
    this.tech().el().el().addEventListener('keyup', (e) => {
      if (this.isWhitelisted(e.code)) {
        const eventTimestamp = this._eventTimestamp[e.code];
        this.handleKeyupEvent(e.code, eventTimestamp);
      }
    });
  }

  bindKeydown() {
    this.tech().el().el().addEventListener('keydown', (e) => {
      if (this.isWhitelisted(e.code)) {
        this.markState(e.code);

        if (e.code == 'ArrowLeft') {
          this._time = Throttle.execute(this._time, this._throttleInterval, this.callbackLeft.bind(this));
        } else if (e.code == 'ArrowRight' ) {
          this._time = Throttle.execute(this._time, this._throttleInterval, this.callbackRight.bind(this));
        } else if (e.code == 'Space' || e.code == 'KeyK') {
          e.preventDefault();
          this.callbackSpaceAndKeyK();
        }
      }
    });
  }

  handleKeyupEvent(keyCode, stateTime) {
    if(Date.now() - stateTime > this.throttleInterval()) {
      PlayerAhoyEvent.sendKeyPressed(keyCode, this.uuid(), true);
    } else {
      PlayerAhoyEvent.sendKeyPressed(keyCode, this.uuid(), false)
    }
    delete this._eventTimestamp[keyCode];
  }

  markState(keyCode) {
    if( !this._eventTimestamp[keyCode] ) {
      this._eventTimestamp[keyCode] = Date.now();
    }
  }

  callbackSpaceAndKeyK() {
    if (this.tech().paused() == true) {
      this.tech().play();
    } else {
      this.tech().pause();
      this.tech().trigger('trigger-pause-ad');
    }
  }

  callbackLeft() {
    if (this.data().isVideo()) {
      this.tech().trigger({
        type: 'vp-before-seeked',
        action: 'keypress'
      });

      const now = this.tech().currentTime();
      this.tech().currentTime(now - this._skipInterval);
    }
  }

  callbackRight() {
    if (this.data().isVideo()) {
      this.tech().trigger({
        type: 'vp-before-seeked',
        action: 'keypress'
      });

      const now = this.tech().currentTime();
      this.tech().currentTime(now + this._skipInterval);
    }
  }

  isWhitelisted(code) {
    return this._whitelistedKeys.indexOf(code) >= 0;
  }

  tech() {
    return this._tech;
  }

  time() {
    return this._time;
  }

  uuid() {
    return this._uuid;
  }

  data() {
    return this._data;
  }

  eventTimestamp() {
    return this._eventTimestamp;
  }

  throttleInterval() {
    return this._throttleInterval;
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
